import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setHeadersProvider, setOnUnauthorized } from './services/api'
import { useSessionStore } from './stores/session'
import { useAuthStore } from './stores/auth'
import { logout } from './services/auth'
import './style.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

const session = useSessionStore()
const auth = useAuthStore()

setHeadersProvider(() => {
  const headers: Record<string, string> = {}
  if (session.workspaceId) {
    headers['x-ax-workspace'] = session.workspaceId
  }
  if (session.suppliedAccId) {
    headers['x-ax-supplied'] = session.suppliedAccId
  }
  return headers
})

setOnUnauthorized(() => {
  auth.clear()
  session.clear()
  logout()
})

app.mount('#app')
